<template lang="html">
<div>
  <v-header/>
  <v-page class="page-register" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">
    <div class="autoRegister">
    <v-login class="card-register">
      <div class="center">
           <div class="registerLeft">
            <div class="company">
              <p>P</p>
              <p>R</p>
              <p>O</p>
              <p>F</p>
              <p>I</p>
              <p>S</p>
              <p>S</p>
              <p>I</p>
              <p>O</p>
              <p>N</p>
              <p>A</p>
              <p>L</p>s
            </div>
            <div>
              <img class="photo" :src="img_url">
            </div>
            </div>
      <div class="registerRight">

        <!-- <v-text tag="h2" class="h4 title center mb-3">Crie sua conta</v-text> -->
        <div class= "titleRegister">
          Cadastre-se gratuitamente <br> para
           <span class="spanColor">contratar profissionais</span>
          </div>

        <v-input type="text" id="signup-first-name" placeholder="Nome" class="inputRegister" v-model="name"/>

        <v-input type="text" id="signup-last-name" placeholder="Sobrenome" v-model="lastname"/>

        <v-input type="email" id="signup-email" v-model="email" placeholder="E-mail"/>

        <v-input type="tel" id="signup-phone" placeholder="Celular/Whatsapp"  v-model="cel_phone"/>

          <v-input
                  type="select"
                  :options="optionsPosition"
                  class= "SelectRegister"
                  v-model="position"
                  placeholder="Área"
                  />
        <v-row :size="1">
          <v-col :md="6">
          <v-input type="password" id="signup-password" placeholder="Senha" v-model="password"/>

          </v-col>
          <v-col :md="6">
            <v-input
              type="repassword"
              id="signup-repassword"
              :repassword="password"
              v-model="confirm_password"
              placeholder= "Repetir senha"/>


          </v-col>
        </v-row>
        <small>
          <v-input type="checkbox" id="login-remember" v-model="accepted_term">
            Declaro que li e concordo com os
            <v-link  class="profForgot" :to="{ name: 'accept' }" target="_blank"
              >termos de aceite da plataforma Vibbra</v-link
            >
          </v-input>
        </small>
        <v-button
          class="block primary"
          @click="signup()"
          style="background-color: #458b23; color:white"
          :disabled="!accepted_term"
          >Criar conta</v-button
        >

        <v-text tag="p" class=" lastInfo "
          >Já possui uma conta? <v-link :to="{name: 'vibbrant-login' }" class="profForgot">Faça seu login</v-link>
        </v-text>
      </div>
      </div>
    </v-login>
    </div>
  </v-page>
  </div>
</template>

<script>
import apiClient from '@/api/client';
// import apiVibbrante from '@/api/vibbrante'

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      name: '',
      lastname: '',
      city: '',
      email: '',
      password: '',
      confirm_password: '',
      accepted_term: false,
      cel_phone: '',
      img_url: require('../../assets/photoPeople/maria-verde.png'),
      position:'',
      optionsPosition: ['Agrotech', 'Alimetação e bebidas', 'aviação', 'comercio/varejo', 'Contrução civil/arquitetura', 'Dados', 'Design', 'E-commerce', 'Edutech', 'Energia', 'Fintech/investimentos', 'govtech', 'Healthtech', 'Imobiliária', 'Indústria', 'jurídico', 'Logística', 'Marketing e publicidade','Turismo', 'outro' ],
      img_background_url: require('../../assets/background/fundo-verde.svg'),
    };
  },
  methods: {
    signup() {
      if (this.profile === 'client') {
        apiClient
          .sign_up(
            this.email,
            this.password,
            this.confirm_password,
            this.name,
            this.lastname,
            this.accepted_term,
            this.cel_phone
          )
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('registerClient', response);
              this.$router.push({ name: 'client-register-success' });
            }
          })
          .catch((e) => {
            this.$children[0].showErrorMsg({ message: e });
          });
      } else {
        /* apiVibbrante.sign_up(this.email, this.password, this.confirm_password, this.name, this.nickname, this.accepted_term).then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('registerVibbrante', response)
            this.$router.replace('/vibbrant')
          }
        }).catch((e) => {
           this.$notify(e, 'error')
        }) */
      }
    },
  },
};
</script>

<style lang="scss">
.page-register {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .autoRegister {
    width: 75%;
  }
  .card-register {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    @include media-breakpoint-up(md) {
      width: 100%;
    }
    .center {
    display: flex;
    align-items: center;
    padding: 2rem 2rem 0 0;

    @include media-breakpoint-down(md) {
      padding: 2rem;
    }
  }
  .registerLeft {
    display: flex;
    align-items: flex-end;

    height: 100%;
    width: 60%;
    @include media-breakpoint-down(md) {
      display: none;
    }

  }



    .photo {
      display: block;
      height: 700px;
      margin-top: 6px;
    }
    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
    .registerRight {
      width: 40%;
      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }

 }
     .titleRegister{
        font-size: 35px;
        font-weight: bold;
        margin-bottom: 40px;

        @include media-breakpoint-down(md) {
          font-size: 25px;
        }

      }

 .spanColor{
          color:#0377aa;
        }

  .inputRegister{
    border-radius: 20px !important;
  }
  .profForgot {
      color: #458b23 !important;
    }
    .lastInfo {
    margin-top:20px ;
  }
   .SelectRegister{
    .multiselect__placeholder{
    color: rgb(72, 72, 72) !important;
  }
   }

    footer.page-footer {
    color: white;
    margin-top: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/registerProfissional.vue